export default {"src":"/_next/static/media/refurbished.98de3038.svg","height":33,"width":33};